import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-214f793e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-wrapper" }
const _hoisted_2 = { class: "results-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_SearchResult = _resolveComponent("SearchResult")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SearchInput, {
      onSearch: _cache[0] || (_cache[0] = ($event: any) => (_ctx.search($event.text)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SearchResult, {
        search: _ctx.searchText,
        previewForecasts: _ctx.previewForecasts,
        url: _ctx.url
      }, null, 8, ["search", "previewForecasts", "url"])
    ])
  ]))
}